import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

/**
 * O react-snap grava um HTML pre-renderizado por rota. Quando o servidor devolve o
 * index.html em uma rota desconhecida (fallback de SPA), o markup em tela e o da home,
 * e hidratar sobre ele deixa atributos obsoletos: o React 16 corrige o texto, mas nao
 * o className. Por isso so hidratamos quando o markup pertence a rota atual.
 *
 * @param {string} path
 * @returns {string}
 */
const normalizePath = (path) =>
  path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;

const prerenderedPath = rootElement.dataset.snapPath;
const currentPath = normalizePath(window.location.pathname);
const isPrerenderedForCurrentPath =
  prerenderedPath !== undefined && normalizePath(prerenderedPath) === currentPath;

rootElement.dataset.snapPath = currentPath;

if (rootElement.hasChildNodes() && isPrerenderedForCurrentPath) {
  ReactDOM.hydrate(app, rootElement);
} else {
  rootElement.innerHTML = '';
  ReactDOM.render(app, rootElement);
}
